import { render } from "./Home.vue?vue&type=template&id=014be51c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=014be51c&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script